import Planificaciones from './planificaciones.vue';
import PlanificacionForm from './planificacion-form.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [{
        path: '/planificacion/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('planificacion', ['ADMIN', 'INSPECTOR'], Planificaciones),
        keepAlive: true
    },
    {
        path: '/planificacion/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('planificacion/view', ['ADMIN', 'INSPECTOR'], PlanificacionForm, { editable: false })
    }
];
export default routes;
